// GA4 event helper
export const GA_ID = 'G-BPDR942YTX';

export type GaEventParams = Record<string, string | number | boolean | null | undefined>;

export function gtag(...args: any[]) {
  if (typeof window === 'undefined') {
    return;
  }
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  w.dataLayer.push(args);
}

export function gaEvent(eventName: string, params: GaEventParams = {}) {
  const safeParams: GaEventParams = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null) {
      safeParams[key] = value;
    }
  }
  gtag('event', eventName, safeParams);
}

export function gaPageView(path: string, title?: string) {
  gaEvent('page_view', { page_path: path, page_title: title });
}

export function gaClick(label: string, params?: GaEventParams) {
  gaEvent('click', { click_label: label, ...params });
}

export function gaCta(label: string, location: string, href?: string) {
  gaEvent('cta_click', { cta_label: label, cta_location: location, cta_href: href });
}

export function gaFormStart(formName: string) {
  gaEvent('form_start', { form_name: formName });
}

export function gaFormSubmit(formName: string, success = true) {
  gaEvent('form_submit', { form_name: formName, success });
}

export function gaExternalLink(href: string, label?: string) {
  gaEvent('outbound_click', { outbound_url: href, link_label: label });
}

export function gaLanguageSwitch(lang: string) {
  gaEvent('language_switch', { language: lang });
}

export function gaScroll(depth: number) {
  gaEvent('scroll', { percent_scrolled: depth });
}

export function gaVideoPlay(videoName: string) {
  gaEvent('video_play', { video_name: videoName });
}
